import ParticleWave from './ParticleWave.vue';

export default ParticleWave;
